import ip_commandAction from "./ip_commandAction";

/**
 * opens inPoint.Client to browse to the specified itemUri
 *
 * @param {{ itemUri: string }} { itemUri }
 */

class ip_browse extends ip_commandAction {
    execute = ({ itemUri }: { itemUri: string }) =>
        super.execute({ itemUri, commandAction: "ItemBrowseCommandAction" });
}

export default ip_browse;
